import { VariableDataBinding } from 'editor/src/store/design/types';

import { VariableDataRow } from './types';

/**
 * The value a column holds for rendering: the given row's when one is being
 * materialised, the binding's sample row's otherwise. Undefined for a column
 * the binding does not know, so a stale binding reads as empty rather than as
 * the column name.
 *
 * Takes the binding rather than the design because that is all it reads, and
 * callers that hold one without a design would otherwise have to invent a
 * design around it.
 */
function getVariableDataColumnValue(
  binding: VariableDataBinding | undefined,
  column: string,
  row?: VariableDataRow,
): string | undefined {
  const source = row ?? binding?.sampleRow;
  const value = source?.[column];
  return typeof value === 'string' ? value : undefined;
}

export default getVariableDataColumnValue;
